import React,{useState,useEffect,useRef} from "react";
import { getNewCondidatePreviousEmpDetailsList } from "../../../Redux/Actions/newJoinerAction";
import {addCandidatePreviousEmpDetails,updateCandidatePreviousEmpDetails} from '../../HR/onboarding/api/Calls'
import { useDispatch } from "react-redux";
import moment from 'moment';
const AddPreviousEmpModel = ({edit,userID,setSelected}) =>{
    const dispatch = useDispatch()
    const cancelRef = useRef(null);
    const reliving_letter = useRef(null);
    const [company_name,Setcompany_name] = useState('');
    const [position,Setposition] = useState('');
    const [supervisor,Setsupervisor] = useState('');
    const [from_date,Setfrom_date] = useState('');
    const [to_date,Setto_date] = useState('');
    const [address_employer,Setaddress_employer] = useState('');
    const [reason_leaving,Setreason_leaving] = useState('');

    const [supervisor_mobno,Setsupervisor_mobno] = useState('');
    const [total_pre_ctc,Settotal_pre_ctc] = useState('');

   
const [RelivingLetterDoc,setRelivingLetter] = useState('');
const [AppointmentLetter ,setAppointmentLetter] = useState('');


const handleCancel = () => {
    setSelected(null);
    Setcompany_name('');
    Setposition('')
    Setsupervisor('')
    Setfrom_date('')
    Setto_date('')
    Setaddress_employer('')
    Setreason_leaving('')
    Setsupervisor_mobno('');
    Settotal_pre_ctc('');
    setRelivingLetter('');
    setAppointmentLetter('');
};

const handleNumericsupervisorChange =(e) =>{
    const onlyNumber = e.target.value;
    const re = /^[0-9]*[.,]?[0-9]*$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      Setsupervisor_mobno(onlyNumber);
    }
 }
 const handleNumericCTCChange =(e) =>{
  const onlyNumber2 = e.target.value;
  //alert(onlyNumber2)
  const re = /^[0-9]*[.,]?[0-9]*$/;
  if (e.target.value === '' || re.test(e.target.value)) {
    Settotal_pre_ctc(onlyNumber2);
  }
}
const handleRelivingLetterChange =  (e) => {
    setRelivingLetter(e.target.files[0]);
};
const handleAppointmentLetterChange =  (e) => {
    setAppointmentLetter(e.target.files[0]);
};
useEffect(() =>{
    if(edit) { Setcompany_name(edit.company_name)}else{Setcompany_name('')}
    if(edit) { Setposition(edit.position) }else{ Setposition('') }
    if(edit) { Setsupervisor(edit.supervisor) }else{Setsupervisor('')}
    if(edit) { Setfrom_date(edit.from_date)}else{ Setfrom_date('')}
    if(edit) { Setto_date(edit.to_date)}else{ Setto_date('')}
    if(edit) { Setsupervisor_mobno(edit.supervisor_mobno)}else{ Setsupervisor_mobno('')}
    if(edit) { Setaddress_employer(edit.address_employer) }else{ Setaddress_employer('')}
    if(edit) { Setreason_leaving(edit.reason_leaving) }else{ Setreason_leaving('')}
    if(edit) { Settotal_pre_ctc(edit.total_pre_ctc) }else{ Settotal_pre_ctc ('')}
   // if(edit) setNumeric({supervisor_mobno:edit.supervisor_mobno,total_pre_ctc:edit.total_pre_ctc});
    if(edit) { setRelivingLetter(edit.reliving_letter); }else{ setRelivingLetter('')}
    if(edit) { setAppointmentLetter(edit.appointment_letter); }else{ setAppointmentLetter('')}
   

},[edit,userID])
    const handleSubmit = (e) =>{
        e.preventDefault();
         if(company_name ==='' || position ==='' || supervisor ==='' || from_date ==='' || 
         to_date ==='' || address_employer ==='' || reason_leaving ==='' || supervisor_mobno ==='' || 
         total_pre_ctc ==='' || RelivingLetterDoc === '' || AppointmentLetter === '')
         {
            return alert('All field is required !');
         }else{
             const formdata = new FormData();
                formdata.append('user_id',userID);
                formdata.append('company_name', company_name);
                formdata.append('position', position);
                formdata.append('supervisor', supervisor);
                formdata.append('from_date', from_date);
                formdata.append('to_date', to_date);
                formdata.append('address_employer', address_employer);
                formdata.append('reason_leaving', reason_leaving);
                formdata.append('supervisor_mobno', supervisor_mobno);
                formdata.append('total_pre_ctc', total_pre_ctc);
                formdata.append('reliving_letter', RelivingLetterDoc);
                formdata.append('appointment_letter', AppointmentLetter);
                formdata.append('created_by', userID);
                formdata.append('created_on',new Date('YYYY-mm-dd'))
             addCandidatePreviousEmpDetails(formdata).then((res) =>{
                if (res.status) {
                  Setcompany_name('');
                  Setposition('')
                  Setsupervisor('')
                  Setfrom_date('')
                  Setto_date('')
                  Settotal_pre_ctc('')
                  Setaddress_employer('')
                  Setreason_leaving('')
                  setRelivingLetter('');
                  setAppointmentLetter('');
                    // setValues(initialPreviousEmpValues);
                    // setNumeric(NumericPreviousEmpValueState)
                    
                    cancelRef.current.click();
                    dispatch(getNewCondidatePreviousEmpDetailsList(userID));
                    return alert(res.msg)
                }else{
                    return alert(res.msg)
                }
            })
         }
    }
    const handleUpdateInfo = (e) =>{
        e.preventDefault();
        if(company_name ==='' || position ==='' || supervisor ==='' || from_date ==='' || 
        to_date ==='' || address_employer ==='' || reason_leaving ==='' || supervisor_mobno ==='' || 
        total_pre_ctc ==='' || RelivingLetterDoc === '' || AppointmentLetter === '')
        {
           return alert('All field is required !');
        }else{
            const formdata = new FormData();
               formdata.append('company_name', company_name);
               formdata.append('position', position);
               formdata.append('supervisor', supervisor);
               formdata.append('from_date', from_date);
               formdata.append('to_date', to_date);
               formdata.append('address_employer', address_employer);
               formdata.append('reason_leaving', reason_leaving);
               formdata.append('supervisor_mobno', supervisor_mobno);
               formdata.append('total_pre_ctc', total_pre_ctc);
               formdata.append('reliving_letter', RelivingLetterDoc);
               formdata.append('appointment_letter', AppointmentLetter);
               formdata.append('updated_by', userID);
            updateCandidatePreviousEmpDetails(formdata,edit.id).then((res) =>{
               if (res.status) {
                Setcompany_name('');
                Setposition('')
                Setsupervisor('')
                Setfrom_date('')
                Setto_date('')
                Setaddress_employer('')
                Settotal_pre_ctc('')
                Setreason_leaving('')
                setRelivingLetter('');
                setAppointmentLetter('');
                    // setValues(initialPreviousEmpValues);
                    // setNumeric(NumericPreviousEmpValueState)
                   cancelRef.current.click();
                   dispatch(getNewCondidatePreviousEmpDetailsList(userID));
                   return alert(res.msg)
               }else{
                   return alert(res.msg)
               }
           })
        }
    }
    const changeAppointmentUploadHandler = (e) =>{
      e.preventDefault();
      setAppointmentLetter('');
    }
    const changeRelivingLetterDocHandler = (e) =>{
      e.preventDefault();
      setRelivingLetter('');
      reliving_letter.current.value = null;
    }
    //const {company_name,position,supervisor,from_date,to_date,address_employer,reason_leaving} = values
   // const {supervisor_mobno,total_pre_ctc} = Numeric;
    return(
        <>
        <div className="modal fade" id="previouscompanydetail" tabIndex={-1} aria-labelledby="previousModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="float-end btn_close" ref={cancelRef} onClick={handleCancel} data-bs-dismiss="modal" aria-label="Close">
                  <i className="icon icon-cross" />
                </button>
                <div className="dash_white_box_ttl text-center mb10" id="previousModalLabel">{edit === null ?'Add':'Update'} Previous Employment Detail</div>
                <form>
                  <div className="row mb10">
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Company Name <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="company_name" value={company_name} onChange={(e)=>Setcompany_name(e.target.value)} id="company_name" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Title of Position <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="position" value={position} onChange={(e)=>Setposition(e.target.value)} id="position" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Name of Supervisor <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="supervisor" value={supervisor} onChange={(e)=>Setsupervisor(e.target.value)} id="supervisor" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Phone Number of Supervisor <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="supervisor_mobno" value={supervisor_mobno} onChange={handleNumericsupervisorChange} id="supervisor_mobno" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-blk mb15">
                        <div className="col-form-label">From Date <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="date" name="from_date" value={moment(from_date).format('yyyy-MM-DD')} onChange={(e)=>Setfrom_date(e.target.value)} id="from_date" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-blk mb15">
                        <div className="col-form-label">To Date <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                       
                      
                          <input type="date" name="to_date" value={moment(to_date).format('yyyy-MM-DD')} id="to_date" onChange={(e)=>Setto_date(e.target.value)} className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Total CTC including Benefits <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="total_pre_ctc" value={total_pre_ctc} onChange={handleNumericCTCChange} id="total_pre_ctc" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Address of Employer <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="address_employer" value={address_employer}  onChange={(e)=>Setaddress_employer(e.target.value)} id="address_employer" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Reason for Leaving </div>
                        <div className="form-input">
                          <input type="text" name="reason_leaving" value={reason_leaving} onChange={(e)=>Setreason_leaving(e.target.value)}  id="reason_leaving" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Upload Reliving Letter <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {RelivingLetterDoc !=''?
                          <input type="file" name="reliving_letter" ref={reliving_letter} onChange={handleRelivingLetterChange} className="form-control uploadbtn" id="reliving_letter" />
                          :
                          <input type="file" name="reliving_letter" ref={reliving_letter} onChange={handleRelivingLetterChange} className="form-control uploadbtn" id="reliving_letter" />
                          }
                          {RelivingLetterDoc != ''?<button className="btn_2 btn-2" onClick={changeRelivingLetterDocHandler}><i className="icon icon-cross"></i></button>:''}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Upload Appointment Letter <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {AppointmentLetter !='' ?
                          <input type="file" name="appointment_letter"  onChange={handleAppointmentLetterChange} className="form-control uploadbtn" id="appointment_letter"  />
                          :
                          <input type="file" name="appointment_letter"  onChange={handleAppointmentLetterChange} className="form-control uploadbtn" id="appointment_letter" />}
                          
                          {AppointmentLetter != ''?<button className="btn_2 btn-2" onClick={changeAppointmentUploadHandler}><i className="icon icon-cross"></i></button>:''}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="modalfooter">
                  <button type="button" className="btn_6 float-end ml10" ref={cancelRef} onClick={handleCancel} data-bs-dismiss="modal">Cancel</button>
                  <button type="button" className="btn_5 float-end " onClick={edit === null ? handleSubmit:handleUpdateInfo} >{edit === null ?'Add':'Update'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    )
}
export default AddPreviousEmpModel;